module.exports = __webpack_public_path__ + "static/media/aterim.3eb706cd.png";